import React from 'react';
import { Box } from '@mui/material';
import styles from './styles.module.css';
import LoadingPlaceholderBlock from '../../../../common/LoadingPlaceholderBlock';

const Placeholder = ({ width, height, mt, mb }) => (
    <Box mt={mt} mb={mb}>
        <LoadingPlaceholderBlock
            width={width}
            height={height}
            borderRadius={"6px"}
            backgroundColor={"#EFEAE5"}
        />
    </Box>
);

export default function ConversationEmptyState() {
    return (
        <div className={styles.retainMsgRightContainerInner}>
            <div className={styles.retainContentWrapper}>
                <div className={styles.conversationContainer}>
                    <div className="retain-md-msg-container">
                        <div className="conversation-item-container">
                            <div className="conversation-item-row">
                                <div className={`${styles["msgMetaDetails"]} ${styles["retainHeader"]}`}>
                                    <div className={styles.retainConvoBoxHeading}>
                                        <Placeholder width="270px" height="22px" />
                                    </div>
                                    <div className={styles.retainMetricsDetailDateTime}>
                                        <span className="metrics-detail-date retain-metrics-detail-date">
                                          <Placeholder width="130px" height="17px" />
                                        </span>
                                    </div>
                                </div>

                                <div className={`${styles.retainMetricsDetailFullMsg} ${styles.retainOutgoingMsg}`}>
                                    <Box sx={{padding: "14px 8px"}}>
                                        <Placeholder width="100px" height="13px" mt={0} />

                                        <Box mt="22px">
                                            {[...Array(4)].map((_, i) => (
                                                <Placeholder key={`block1-${i}`} width="100%" height="13px" mb="10px" />
                                            ))}
                                        </Box>

                                        <Box mt="22px">
                                            {[...Array(3)].map((_, i) => (
                                                <Placeholder key={`block2-${i}`} width="100%" height="13px" mb="10px" />
                                            ))}
                                            <Placeholder width="50%" height="13px" mb="10px"  />
                                        </Box>

                                        <Placeholder width="400px" height="400px" mt="20px" />

                                        <Box mt="22px">
                                            <Placeholder width="250px" height="13px" mb="20px" />
                                            <Placeholder width="100px" height="13px" mb="10px" />
                                            <Placeholder width="150px" height="13px" />
                                        </Box>
                                    </Box>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
